import { SharingState } from '@/store/types';
import { MutationTree } from 'vuex';
import { Invitation } from '@/models/invitation';

const mutations: MutationTree<SharingState> = {
  setInvitations(state: SharingState, invitations: Invitation[]): void {
    state.table.invitations = invitations;
  },
  setInvite(state: SharingState, invite: Invitation): void {
    state.invite = invite;
  },
  setInviteEmail(state: SharingState, email: string): void {
    state.invite.email = email;
  },
  clearInvite(state: SharingState): void {
    state.invite.email = '';
  },
  select(state: SharingState, selected: Invitation): void {
    state.selected = selected;
  },
  remove(state: SharingState): void {
    state.selected.state = 'REVOKED';
  },
  add(state: SharingState, invitation: Invitation): void {
    let resend = false;
    state.table.invitations = state.table.invitations.map(invite => {
      if (invite.email === invitation.email) {
        resend = true;
        return invitation;
      } else return invite;
    });

    if (!resend) state.table.invitations.push(invitation);
  },

  setGetError(state: SharingState, message: string): void {
    state.requestError.get.message = message;
  },
  clearGetError(state: SharingState): void {
    state.requestError.get.message = '';
  },
  setPostError(state: SharingState, message: string): void {
    state.requestError.post.message = message;
  },
  clearPostError(state: SharingState): void {
    state.requestError.post.message = '';
  },
  setPutError(state: SharingState, message: string): void {
    state.requestError.put.message = message;
  },
  clearPutError(state: SharingState): void {
    state.requestError.put.message = '';
  },
  setDeleteError(state: SharingState, message: string): void {
    state.requestError.delete.message = message;
  },
  clearDeleteError(state: SharingState): void {
    state.requestError.delete.message = '';
  },
  clearErrors(state: SharingState) {
    state.requestError.get.message = '';
    state.requestError.post.message = '';
    state.requestError.put.message = '';
    state.requestError.delete.message = '';
  },
};

export default mutations;
